// Grid clustering untuk kapal dan landmark

// eslint-disable-next-line import/prefer-default-export
export function clusterByGrid(items, cellSize, getLatLng) {
  if (!Array.isArray(items) || items.length === 0) return [];
  const ukuran = Number(cellSize);
  if (!(ukuran > 0)) return [];

  const sel = new Map();
  items.forEach((item) => {
    const posisi = getLatLng(item) || [];
    const lat = Number(posisi[0]);
    const lng = Number(posisi[1]);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

    const kunci = `${Math.floor(lat / ukuran)}:${Math.floor(lng / ukuran)}`;
    if (!sel.has(kunci)) sel.set(kunci, { sumLat: 0, sumLng: 0, items: [] });
    const isi = sel.get(kunci);
    isi.sumLat += lat;
    isi.sumLng += lng;
    isi.items.push(item);
  });

  const hasil = [];
  sel.forEach((isi) => {
    hasil.push({
      lat: isi.sumLat / isi.items.length,
      lng: isi.sumLng / isi.items.length,
      items: isi.items,
    });
  });
  return hasil;
}
